export type GetElement = (selector: string) => Element | null;
export type SetAttr = (element: Element, attr: string, param: string) => void;
export type RemoveAttr = (element: Element, attr: string) => void;
type UpdateElement = {
  (
    getElement: GetElement,
    setAttr: SetAttr,
    selector: string,
    attr: string,
    fixedValue: string
  ): () => void;
  (getElement: GetElement, setAttr: SetAttr, selector: string, attr: string): (
    value: string
  ) => void;
};

/**
 * WCの要素の取得
 *
 * @param selector セレクター
 */
export const getElement: GetElement = (selector) => {
  return document.querySelector(selector);
};

/**
 * 要素に属性を付与する
 *
 * @param element エレメント
 * @param attr 属性名
 * @param param パラム
 */
export const setAttr: SetAttr = (element, attr, param) => {
  element.setAttribute(attr, param);
};

/**
 * 要素の属性を削除する
 *
 * @param element エレメント
 * @param attr 属性名
 */
export const removeAttr: RemoveAttr = (element, attr) => {
  element.removeAttribute(attr);
};

/**
 * 指定の要素が存在しているとき、要素の属性を更新する
 *
 * @param selector 任意の要素のセレクタ
 * @param attr 属性名
 * @param fixedValue 属性に設定する値
 */
export const updateElement: UpdateElement = (
  getElement: GetElement,
  setAttr: SetAttr,
  selector: string,
  attr: string,
  fixedValue?: string
) => (value?: string) => {
  const element = getElement(selector);
  if (!element) return;
  if (fixedValue) setAttr(element, attr, fixedValue);
  if (value) setAttr(element, attr, value);
};
